/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosChecklistsChecklistProtocolDto,
  FacilityFlowCoreModulesPlanningDtosChecklistsOpenChecklistProtocolDto,
  GetApiV1ChecklistProtocolOpenParams,
  GetApiV1ChecklistProtocolParams,
  GetApiV1ChecklistProtocolPdfParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getChecklistProtocol = () => {
/**
 * @summary Protokoll eines Tages, optional auf einen Mitarbeiter und/oder ein Objekt eingegrenzt.
 */
const getApiV1ChecklistProtocol = (
    params?: GetApiV1ChecklistProtocolParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsChecklistProtocolDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsChecklistProtocolDto>(
      {url: `/api/v1/checklist-protocol`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Alle vergangenen Tage mit noch offenen Checklistenpunkten, neueste zuerst — optional
auf einen Mitarbeiter und/oder ein Objekt eingegrenzt. Der heutige Tag bleibt außen
vor, der läuft noch und steht im Tagesprotokoll. Mit `includeCompleted` kommen
auch vollständig erledigte Aufgaben dazu, begrenzt auf Tage ab `from`
(Standard: die letzten 14 Tage). Offene bleiben immer enthalten.
 */
const getApiV1ChecklistProtocolOpen = (
    params?: GetApiV1ChecklistProtocolOpenParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsOpenChecklistProtocolDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosChecklistsOpenChecklistProtocolDto>(
      {url: `/api/v1/checklist-protocol/open`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Protokoll eines Tages als PDF (erledigt/offen inkl. Uhrzeit und Foto-Nachweis).
 */
const getApiV1ChecklistProtocolPdf = (
    params?: GetApiV1ChecklistProtocolPdfParams,
 options?: SecondParameter<typeof customInstance<Blob>>,) => {
      return customInstance<Blob>(
      {url: `/api/v1/checklist-protocol/pdf`, method: 'GET',
        params,
        responseType: 'blob'
    },
      options);
    }
  return {getApiV1ChecklistProtocol,getApiV1ChecklistProtocolOpen,getApiV1ChecklistProtocolPdf}};
export type GetApiV1ChecklistProtocolResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getChecklistProtocol>['getApiV1ChecklistProtocol']>>>
export type GetApiV1ChecklistProtocolOpenResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getChecklistProtocol>['getApiV1ChecklistProtocolOpen']>>>
export type GetApiV1ChecklistProtocolPdfResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getChecklistProtocol>['getApiV1ChecklistProtocolPdf']>>>
